<template>
  <vx-card class="editor-mid-card">
    <!-- <vue-perfect-scrollbar class="scroll-area" :settings="settings"> -->
      <div class="mb-base">
        <div class="flex justify-between flex-wrap mb-1">
            <vs-row vs-w="6">
              <h3 class="float-left mr-4">{{ $t('editor.contact.title') }}</h3>
              <vx-tooltip v-if="saveInProgress" text="Saving to cloud...">
                  <feather-icon
                  icon="CloudIcon"
                  class="save-in-progress-status-icon"
                  svgClasses="text-success"
                /></vx-tooltip>
                <vx-tooltip v-else 
                :text="$t('editor.contact.saveToCloud')"
                ><feather-icon
                  icon="CloudIcon"
                  class="save-in-progress-status-icon"
                /></vx-tooltip>
            </vs-row>
            <div>
              <options :previousMove="{ name: 'editor-about'}" :nextMove="{ name: 'editor-career-history'}" />
            </div>
        </div>
        <p v-if="!isUserLoggedIn">
          <span v-if="organizationSlug === 'default'">
            {{ $t('editor.utils.notAuthenticated.youAreNotAuthenticated') }} <router-link :to="{ name: 'editor-about'}">{{ $t('editor.utils.notAuthenticated.login') }}</router-link> {{ $t('editor.utils.notAuthenticated.toSaveYourData') }}
          </span>
          <span v-else>
            {{ $t('editor.utils.notAuthenticated.youAreNotAuthenticated') }} <router-link :to="{ name: 'editor-about-custom'}">{{ $t('editor.utils.notAuthenticated.login') }}</router-link> {{ $t('editor.utils.notAuthenticated.toSaveYourData') }}
          </span>
        </p>
        <!-- <p v-if="!isUserLoggedIn" class="text-danger">
          You are not authenticated. Please login to save your data.
        </p>
        <p v-else-if="internetConnectionStatus">
          Internet Connection Active. Keep editing and your data gets auto-saved.
        </p>
        <p v-else class="text-danger">
          No Internet Connection. Please connect to Internet to save your data.
        </p> -->
      </div>
      <div class="main-form">
        <div class="vx-row">
            <div class="vx-col mb-base w-full md:w-1/2">
              <label>{{ $t('editor.contact.email') }}</label>
              <p class="email" v-if="isUserLoggedIn">{{localData.email}}</p>
              <p v-else style="font-size: 12px;">
                <span v-if="organizationSlug === 'default'">
                  {{ $t('editor.contact.email_2.p1') }}<router-link :to="{ name: 'editor-about'}">{{ $t('editor.contact.email_2.p2') }}</router-link>
                </span>
                <span v-else>
                  {{ $t('editor.contact.email_2.p1') }}<router-link :to="{ name: 'editor-about'}">{{ $t('editor.contact.email_2.p2') }}</router-link>
                </span>
              </p>
            </div>
            <div class="vx-col mb-base w-full md:w-1/2">
              <label>{{ $t('editor.contact.personalWebsite') }}</label>
              <vs-input
                class="w-full dark-input-field"
                name="Personal Website"
                maxlength = "250"
                data-vv-validate-on="blur"
                v-validate="{url: {require_protocol: true }}"
                :disabled="disableInputField"
                v-model="localData.personalWebsite"
                placeholder="https://www.website.com/"
                @blur="saveField('savePersonalWebsite', 'Personal Website')"
              />
              <span class="text-danger text-sm">{{
                errors.first("Personal Website")
              }}</span>
            </div>
        </div>
        <div class="vx-row">
            <div class="vx-col mb-base w-full md:w-1/2">
              <label>{{ $t('editor.contact.skypeProfile') }}</label>
              <vs-input
                class="w-full mb-1 dark-input-field"
                name="Skype Profile"
                maxlength = "250"
                data-vv-validate-on="blur"
                v-validate="{url: {require_protocol: true }, regex: /https:\/\/join\.skype\.com\/invite\/[A-Za-z0-9]+/}"
                :disabled="disableInputField"
                v-model="localData.skypeProfile"
                @blur="saveField('saveSkypeProfile', 'Skype Profile')"
              />
              <span class="text-danger text-sm">{{
                errors.first("Skype Profile")
              }}</span>
            </div>
            <div class="vx-col mb-base w-full md:w-1/2">
              <label>{{ $t('editor.contact.facebookProfile') }}</label>
              <vs-input
                class="w-full dark-input-field"
                name="Facebook Profile"
                maxlength = "250"
                data-vv-validate-on="blur"
                v-validate="{url: {require_protocol: true }, regex: /^(?:(?:http|https):\/\/)?(?:www.)?facebook.com\/(?:(?:\w)*#!\/)?(?:pages\/)?(?:[?\w\-]*\/)?(?:profile.php\?id=(?=\d.*))?([\w\-]*)?$/}"
                :disabled="disableInputField"
                v-model="localData.facebookProfile"
                @blur="saveField('saveFacebookProfile', 'Facebook Profile')"
              />
              <span class="text-danger text-sm">{{
                errors.first("Facebook Profile")
              }}</span>
            </div>
        </div>
        <div class="vx-row">
            <div class="vx-col mb-base w-full md:w-1/2">
              <label>{{ $t('editor.contact.contactNumber') }}</label>
              <vs-input
                class="w-full mb-1 dark-input-field"
                name="Contact Number"
                maxlength = "15"
                data-vv-validate-on="blur"
                v-validate="{regex: /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im}"
                :disabled="disableInputField"
                v-model="localData.contactNumber"
                @blur="saveField('saveContactNumber', 'Contact Number')"
              />
              <span class="text-danger text-sm">{{
                errors.first("Contact Number")
              }}</span>
            </div>
            <div class="vx-col mb-base w-full md:w-1/2">
              <label>{{ $t('editor.contact.twitterProfile') }}</label>
              <vs-input
                class="w-full dark-input-field"
                name="Twitter Profile"
                maxlength="250"
                data-vv-validate-on="blur"
                v-validate="{url: {require_protocol: true }, regex: /(?:http:\/\/)?(?:www\.)?twitter\.com\/(?:(?:\w)*#!\/)?(?:pages\/)?(?:[\w\-]*\/)*([\w\-]*)/}"
                :disabled="disableInputField"
                v-model="localData.twitterProfile"
                @blur="saveField('saveTwitterProfile', 'Twitter Profile')"
              />
              <span class="text-danger text-sm">{{
                errors.first("Twitter Profile")
              }}</span>
            </div>
        </div>
        <div class="vx-row">
            <div class="vx-col mb-base w-full md:w-1/2">
              <label>{{ $t('editor.contact.address') }}</label>
              <vs-textarea
                class="w-full mb-1"
                name="Address"
                maxlength = "360"
                :disabled="disableInputField"
                v-model="localData.address"
                @blur="saveField('saveAddress')"
              />
            </div>
            <div class="vx-col mb-base w-full md:w-1/2">
              <label>{{ $t('editor.contact.linkedinProfile') }}</label>
              <vs-input
                class="w-full dark-input-field"
                name="Linkedin Profile"
                maxlength="250"
                data-vv-validate-on="blur"
                v-validate="{url: {require_protocol: true }, regex: /((https?:\/\/)?((www|\w\w)\.)?linkedin\.com\/)((([\w]{2,3})?)|([^\/]+\/(([\w|\d-&#?=])+\/?){1,}))$/}"
                :disabled="disableInputField"
                v-model="localData.linkedinProfile"
                @blur="saveField('saveLinkedinProfile', 'Linkedin Profile')" 
              />
              <span class="text-danger text-sm">{{ errors.first("Linkedin Profile") }}</span>
            </div>
        </div>
                    <div class="vx-col mb-base w-full md:w-1/2">
              <label>{{ $t('editor.contact.discordProfile') }}</label>
              <vs-input
                class="w-full dark-input-field"
                name="Discord Profile"
                maxlength="250"
                data-vv-validate-on="blur"
                v-validate="{regex: /^.{3,32}#[0-9]{4}$/}"
                :disabled="disableInputField"
                v-model="localData.discordProfile"
                @blur="saveField('saveDiscordProfile', 'Discord Profile')"
              />
              <span class="text-danger text-sm">{{
                errors.first("Discord Profile")
              }}</span>
            </div>
      </div>
    <!-- </vue-perfect-scrollbar> -->
  </vx-card>
</template>

<script>
import FeatherIcon from "../../components/FeatherIcon.vue";
import Options from "./components/Options.vue";
import constants from "@/constants";
import { saveInputFieldService } from "@/services/editor/contact.service.js";
// import _ from "lodash";
import VuePerfectScrollbar from "vue-perfect-scrollbar";

export default {
  components: { FeatherIcon, Options, VuePerfectScrollbar },
  name: "EditorContact",
  data() {
    return {
      localData: {},
      constants,
      settings: {
        suppressScrollX: true,
        maxScrollbarLength: 60,
      },
    };
  },
  computed: {
    otpSent() {
      return this.$store.state.auth.otpSent;
    },
    saveInProgress() {
      return this.$store.state.editor.saveInProgress;
    },
    isUserLoggedIn() {
      return this.$store.state.auth.isUserLoggedIn;
    },
    usersData() {
      return this.$store.state.users.data;
    },
    userId() {
      return this.$store.state.auth.user._id;
    },
    internetConnectionStatus() {
      return this.$store.state.users.internetConnectionStatus;
    },
    disableInputField() {
      return !this.isUserLoggedIn || !this.internetConnectionStatus;
    },
    organizationId() {
      return this.$store.state.organization.orgData._id;
    },
    organizationSlug() {
      return this.$store.state.organization.organizationSlug;
    },
  },
  watch: {
    usersData(newVal) {
      if (newVal) {
        //// console.log(newVal);
        this.localData = JSON.parse(JSON.stringify(newVal));
      }
    },
  },
  methods: {
    checkSocialProfiles() {},
    async saveField(action, fieldName = null) {
      let fieldIsValid = false;

      if (fieldName) {
        fieldIsValid = await this.$validator.validate(fieldName);

        if (!fieldIsValid) {
          return;
        }
      } else {
        fieldIsValid = true;
      }

      //// console.log(fieldIsValid);

      if (fieldName && !fieldIsValid) {
        return;
      }

      const payload = {
        isUserLoggedIn: this.isUserLoggedIn,
        action,
        localData: this.localData,
        userId: this.userId,
        currentThis: this,
      };

      saveInputFieldService(payload);
    },
  },
  created() {
    // this.getActiveOrg();
    this.$store.dispatch("editor/toggleRightBar", true);
    this.$store.dispatch("editor/togglePreviewMode", false);

    //// console.log("contact created");

    if (this.isUserLoggedIn) {
      if (Object.keys(this.usersData).length) {
        this.localData = JSON.parse(JSON.stringify(this.usersData));
        //// console.log(this.localData);
      }
    }
  },
};
</script>

<style scoped>
.scroll-area {
  position: relative;
  margin: auto;
  width: 100%;
  height: 615px;
  /*height: 1000px;*/
}
.email{
  font-size: 1em;
  word-wrap: break-word;
}
.dark-input-field >>> .vs-con-input .vs-input--input {
  background : #edededab !important
}
.vs-con-textarea >>> .vs-textarea {
  background : #edededab !important
}
</style>
